import axios from 'axios';
import { type IBugReportData } from '@/types/IBugReportData';
import { type IBugReportResponse } from '@/types/IBugReportResponse';

/**
 * Тайпгард формы успешного ответа эндпоинта: { response: { id: string } }.
 */
const hasBugReportId = (
  data: unknown
): data is { response: IBugReportResponse } => {
  if (typeof data !== 'object' || data === null || !('response' in data)) {
    return false;
  }

  const { response } = data;
  return (
    typeof response === 'object' &&
    response !== null &&
    'id' in response &&
    typeof response.id === 'string'
  );
};

/**
 * Отправляет bug-report на общий публичный эндпоинт.
 *
 * Намеренно используем «чистый» axios, а не инстанс `api` из utils/api.ts:
 * эндпоинт публичный (токен не нужен), и так сбой отправки не пройдёт через
 * интерсептор `api` — не будет лишнего technicalError-тоста / refresh поверх
 * уже упавшего экрана. Ошибка отправки проглатывается.
 *
 * @returns id созданного отчёта, либо null если отправить не удалось.
 */
export const sendBugReport = async (
  reportData: IBugReportData
): Promise<string | null> => {
  try {
    const url = `${import.meta.env.VITE_API_URL}/api/public/bug-report`;
    const { data } = await axios.post(url, reportData, {
      headers: { 'Content-Type': 'application/json' }
    });

    return hasBugReportId(data) ? data.response.id : null;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Не удалось отправить bug-report:', error);
    return null;
  }
};
